var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shedule"},[_c('div',{staticClass:"chooseSeat"},[_c('choose-seat-back')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }